import React, { useState } from "react";
import { db, auth } from "../firebase";
import { doc, setDoc, collection, addDoc } from "firebase/firestore"; // Add addDoc for adding schemes
import { useNavigate } from "react-router-dom";
import "../styles/Eligibilityform.css"; // CSS file

const EligibilityForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    gender: "",
    caste: "",
    address: "",
    contact: "",
    email: "",
    phone: "",
    aadhar: "",
    pan: "",
    education: "",
    maritalStatus: "",
    employment: "",
    income: "",
    familyMembers: "",
    housingType: "",
    disability: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Function to add schemes based on eligibility data
  const addSchemeToFirestore = async (eligibilityData) => {
    try {
      const schemeRef = collection(db, "schemes");
      const newScheme = {
        name: `Scheme for ${eligibilityData.employment} and ${eligibilityData.income <= 50000 ? "Low Income" : "High Income"}`, // Dynamically create scheme name
        income: eligibilityData.income,
        employment: eligibilityData.employment,
        disability: eligibilityData.disability,
        description: `This scheme is tailored for individuals with ${eligibilityData.employment} status and an income of ₹${eligibilityData.income}.`,
        eligibility: "Check your eligibility based on the form details.",
        applicationProcess: "You can apply through the official portal.",
        link: "https://example.com/apply", // A dummy link; replace with actual link
      };

      // Add the scheme document to Firestore
      await addDoc(schemeRef, newScheme);
      console.log("Scheme added successfully");
    } catch (error) {
      console.error("Error adding scheme:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;

    if (user) {
      // Store the form data in Firestore under 'eligibility'
      await setDoc(doc(db, "eligibility", user.uid), formData);
      alert("Eligibility form submitted!");

      // Add schemes based on eligibility form
      await addSchemeToFirestore(formData);

      navigate("/recommendations"); // Redirect to recommendations
    }
  };

  return (
    <div className="eligibility-container">
      <h2>Check Your Eligibility</h2>
      <form onSubmit={handleSubmit}>
        <label>Name:</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />

        <label>Age:</label>
        <input type="number" name="age" value={formData.age} onChange={handleChange} required />

        <label>Gender:</label>
        <input type="text" name="gender" value={formData.gender} onChange={handleChange} required />

        <label>Caste:</label>
        <input type="text" name="caste" value={formData.caste} onChange={handleChange} required />

        <label>Address:</label>
        <input type="text" name="address" value={formData.address} onChange={handleChange} required />

        <label>Contact:</label>
        <input type="text" name="contact" value={formData.contact} onChange={handleChange} required />

        <label>Email:</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />

        <label>Aadhar Card Number:</label>
        <input type="text" name="aadhar" value={formData.aadhar} onChange={handleChange} required />

        <label>PAN Card Number:</label>
        <input type="text" name="pan" value={formData.pan} onChange={handleChange} required />

        <label>Education Level:</label>
        <select name="education" value={formData.education} onChange={handleChange} required>
          <option value="">Select</option>
          <option value="School">School</option>
          <option value="Graduate">Graduate</option>
        </select>

        <label>Marital Status:</label>
        <input type="text" name="maritalStatus" value={formData.maritalStatus} onChange={handleChange} required />

        <label>Employment Status:</label>
        <select name="employment" value={formData.employment} onChange={handleChange} required>
          <option value="">Select</option>
          <option value="Employed">Employed</option>
          <option value="Unemployed">Unemployed</option>
        </select>

        <label>Annual Income (in INR):</label>
        <input type="number" name="income" value={formData.income} onChange={handleChange} required />

        <label>Number of Family Members:</label>
        <input type="number" name="familyMembers" value={formData.familyMembers} onChange={handleChange} required />

        <label>Housing Type:</label>
        <select name="housingType" value={formData.housingType} onChange={handleChange} required>
          <option value="">Select</option>
          <option value="Owned">Owned</option>
          <option value="Rented">Rented</option>
        </select>

        <label>Disability Status:</label>
        <input type="text" name="disability" value={formData.disability} onChange={handleChange} required />

        <button type="submit">Check Eligibility</button>
      </form>
    </div>
  );
};

export default EligibilityForm;
